import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { useEffect, useState } from "react";
import Footer from "./components/Footer";
import Header from "./components/Header";
import { AnimationProvider } from "./contexts/AnimationContext";
import Login from "./pages/LoginPage";
import Home from "./sections/Home";
import Registry from "./sections/Registry";
import RSVP from "./sections/RSVP";
import TravelAndStay from "./sections/TravelAndStay";
import theme from "./theme";

function App() {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Preload hero image
    const img = new Image();
    img.src =
      "https://res.cloudinary.com/dzwnnnku5/image/upload/v1769462238/Azore_Laggon_HD_dqzr6f.jpg";
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AnimationProvider>
        <div>
          {isUserLoggedIn ? (
            <>
              <Header />
              <Home />
              <TravelAndStay />
              <Registry />
              <RSVP />
              <Footer />
            </>
          ) : (
            <Login onLogin={() => setIsUserLoggedIn(true)} />
          )}
        </div>
      </AnimationProvider>
    </ThemeProvider>
  );
}

export default App;
